import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ProvidedService} from '../model/provided-service';
import {Observable} from 'rxjs/Observable';
import {FindHttpError} from '../error/find-http-error';

@Injectable()
export class ProvidedServiceService {
  private static PROVIDED_SERVICE_END_POINT = '/providedService';

  private FIND_ALL = ProvidedServiceService.PROVIDED_SERVICE_END_POINT + '/findAll';

  constructor(private _http: HttpClient) { }

  findAll() {
    return this._http.get(this.FIND_ALL)
      .map(res => <Array<ProvidedService>>res)
      .catch(error => Observable.throw(new FindHttpError(error._body)));
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/service/provided-service.service.ts